import { Children } from "react";
import styled from "styled-components";

interface Props {
  children: React.ReactNode;
}

const Container = styled.main`
  overflow-y: auto;
  scroll-behavior: smooth;
`;

const Main = (props: Props) => {
  const { children } = props;
  return (
    <>
      <Container>{children}</Container>
    </>
  );
};

export default Main;
